/** Decision signature statuses (mirrors SignatureStatusEnum on the API). */
export enum DecisionSignatureStatus {
	Pending = 1,
	Signed = 2,
}
